type FilterOption = {
  key: string;
  label: string;
  value: string;
  options: string[];
};

type FilterPanelProps = {
  groups: FilterOption[];
  onChange: (key: string, value: string) => void;
  onReset: () => void;
  activeCount: number;
};

export default function FilterPanel({ groups, onChange, onReset, activeCount }: FilterPanelProps) {
  return (
    <div className="rounded-lg border border-background-200 bg-background-50 p-4 md:p-5">
      <div className="mb-4 flex items-center justify-between border-b border-background-200 pb-3">
        <h2 className="flex items-center gap-1.5 text-sm font-medium text-foreground-950">
          <i className="ri-filter-3-line text-primary-600"></i>
          筛选条件
        </h2>
        <button
          type="button"
          onClick={onReset}
          disabled={activeCount === 0}
          className={`cursor-pointer whitespace-nowrap text-xs transition ${
            activeCount === 0
              ? "cursor-not-allowed text-foreground-300"
              : "text-accent-700 hover:text-accent-600"
          }`}
        >
          重置{activeCount > 0 ? ` (${activeCount})` : ""}
        </button>
      </div>

      <div className="space-y-5">
        {groups.map((group) => (
          <div key={group.key}>
            <p className="mb-2 text-xs text-foreground-500">{group.label}</p>
            <div className="flex flex-wrap gap-1.5">
              {["全部", ...group.options].map((option) => {
                const active = group.value === option;
                return (
                  <button
                    key={`${group.key}-${option}`}
                    type="button"
                    onClick={() => onChange(group.key, option)}
                    className={`cursor-pointer whitespace-nowrap rounded-md border px-2.5 py-1.5 text-xs transition ${
                      active
                        ? "border-primary-500 bg-primary-500 text-background-50"
                        : "border-background-200 bg-background-50 text-foreground-600 hover:border-primary-300 hover:text-primary-600"
                    }`}
                  >
                    {option}
                  </button>
                );
              })}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}